/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitiateExternalTransactionReversalRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {InitiateExternalTransactionReversalResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const initiateExternalTransactionReversal = (request: InitiateExternalTransactionReversalRequest, options?: CashRequestOptions) => post<InitiateExternalTransactionReversalRequest, InitiateExternalTransactionReversalResponse>("/2.0/cash/initiate-external-transaction-reversal", request, {...options, rejectOnError: true })